<div class="hw-box-content">
    <div class="hw-header-wrap">
        <div class="row">
            <div class="col-6">
                <i class="fn-global-site"></i>
                SLA Report
            </div>
        </div>
    </div>
    <div class="hw-title">
        <div class="row">
            <div class="col-12">
                <ul class="list-inline">
                    <li class="align-top">
                        <fn-date-range-picker [startDate]="dateRangeObject.startDate" [futureDateDisabled]="true"
                            [maxDate]="maxDateRange" (dateCB)="changeDate($event)" [endDate]="dateRangeObject.endDate">
                        </fn-date-range-picker>
                    </li>
                    <li class="align-top pt-7 width-100px">
                        <div class="form-check">
                            <label class="form-check-label" for="inlineFormCheck">
                                Select Severity
                            </label>
                        </div>
                    </li>
                    <li class="align-top width-200px">
                        <fn-select [labelKey]="'name'" [inputKey]="'name'" [optionList]="severityArray"
                            [placeholder]="'Search ID..'" [(ngModel)]="selectSeverity" appendTo="body"
                            [ngModelOptions]="{ standalone: true }">
                        </fn-select>
                    </li>
                    <li class="align-top pt-7">
                        <div class="form-check">
                            <label class="form-check-label" for="inlineFormCheck">
                                Select Product
                            </label>
                        </div>
                    </li>
                    <li class="align-top width-210px">
                        <fn-select [labelKey]="'name'" [inputKey]="'primaryKey'" [optionList]="productArray"
                            (changeEvent)="filterIdenNo()" [placeholder]="'Select Product'" [(ngModel)]="selectProduct"
                            [ngModelOptions]="{standalone: true}">
                        </fn-select>
                    </li>
                    <li class="align-top pt-7 width-100px">
                        <div class="form-check">
                            <label class="form-check-label" for="inlineFormCheck">
                                Select IdenNo
                            </label>
                        </div>
                    </li>
                    <li class="align-top width-210px ">
                        <fn-select [labelKey]="'idenNo'" [inputKey]="'idenNo'" [optionList]="idenNoArray"
                            [placeholder]="'Select idenNo'" [(ngModel)]="selectIdenNo"
                            [ngModelOptions]="{standalone: true}">
                        </fn-select>
                    </li>
                    <li class="align-top pt-7">
                        <div class="form-check">
                            <label class="form-check-label" for="findBy">SLA</label>
                        </div>
                    </li>
                    <li class="align-top pt-7">
                        <fn-switch [(ngModel)]="isSLA" [name]="'isSLA'"></fn-switch>
                    </li>
                    @if(!isSLA){
                    
                    <li class="align-top width-200px">
                        <fn-select [labelKey]="'value'" [inputKey]="'key'" [optionList]="durationArray"
                            [placeholder]="'Select Duration..'" [(ngModel)]="selectDuration" appendTo="body"
                            [ngModelOptions]="{ standalone: true }">
                        </fn-select>
                    </li>
                    }
                    <li class="align-top pt">
                        <fn-button [type]="'primary'" [btnClass]="'btn-sm btn-round'" [text]="'GO'"
                            (click)="getHistData(selectIdenNo)"></fn-button>
                    </li>
                   
                    @if(alertArray.length >0){
                    <li class="align-top pt">
                        <fn-button [type]="'success'" [btnClass]="'btn-sm btn-round'" [text]="'Download CSV'"
                            (click)="downloadCsv()"></fn-button>
                    </li>
                    }
                </ul>
            </div>
        </div>
    </div>
    <div class="hw-content">
        <div class="row">
            <div class="col-12">
                @if (uiMap.isDataLoaded) {
                <fn-table [config]='config' [rowMetaArray]='rowMetaArray' [dataArray]='alertArray' [pageSize]="15">
                    <ng-template #customTempRef let-row>
                <i class="fn-global-information"  title="Alert Actions" (click)="infoRowAction(row)"></i>
              </ng-template>  
                </fn-table>
                }
            </div>
        </div>
    </div>
</div>